export * from './dashboard.component';
export * from './dashboard.service';
export * from './dashboard.model';
export * from './dashboard.module';
export * from './sessoes/dashboard-geral/dashboard-geral.component';
export * from './sessoes/dashboard-geral/dashboard-geral.service';
export * from './sessoes/dashboard-diario/dashboard-indicadores-diarios.component';
export * from './sessoes/dashboard-diario/dashboard-indicadores-diarios.service';
export * from './sessoes/dashboard-semanal/dashboard-indicadores-semanais.component';
export * from './sessoes/dashboard-semanal/dashboard-indicadores-semanais.service';
export * from './sessoes/dashboard-anual/dashboard-indicadores-anuais.component';
export * from './sessoes/dashboard-anual/dashboard-indicadores-anuais.service';
